const state = {
  entrance: ''
}
const mutations =  {
  SET_ENTRANCE(state, entrancePage) {
    state.entrance = entrancePage
  }
}

const getters = {
  entrancePage: state => state.entrance
}

export default {
  namespace: true,
  state,
  mutations,
  getters
}




// WEBPACK FOOTER //
// ./src/store/modules/wj.js